import { BigNumber } from 'ethers'
import ReactTooltip from 'react-tooltip'

import { useFarmingAPR } from '~/lib/useFarmingAPR'
import TokenPairCard from '~/components/TokenPairCard'
import Typography from '~/components/Typography'
import { hasProjectTokens } from '~/lib/helpers'

import { PoolWithReward } from '../types'
import APRValue from '../APRValue'

import styles from './FarmList.pcss'
import YourLiquidity from '~/pages/CrossChainFarmPage/YourLiquidity'
import { APRLabel } from './APRLabel'

interface Props {
	data: Array<PoolWithReward>
	onFarmClick: (data: PoolWithReward) => void
}

function FarmList({ data, onFarmClick }: Props) {
	const farmingAPR = useFarmingAPR()

	// const sortedPools = data.sort((a, b) => {
	// 	if (!a.reward?.availableToClaim || !b.reward?.availableToClaim) {
	// 		return 0
	// 	}
	// 	const aBN = BigNumber.from(a.reward.availableToClaim)
	// 	const bBN = BigNumber.from(b.reward.availableToClaim)
	// 	if (aBN.lt(bBN)) {
	// 		return 1
	// 	}
	// 	if (aBN.gt(bBN)) {
	// 		return -1
	// 	}
	// 	return 0
	// })

	return (
		<div className={styles.container}>
			<ReactTooltip
				id="sis"
				place="bottom"
				effect="float"
				className={styles.aprTooltip}
				arrowColor="transparent"
				offset={{
					right: 122,
				}}
			>
				<Typography size="XS">Farming rewards: SIS</Typography>
			</ReactTooltip>

			{data.map((item) => {
				const isOnlySIS = !hasProjectTokens(item.pool)

				return (
					<TokenPairCard
						key={`chain-${item.pool.tokenA.chainId}-chain-${item.pool.tokenB.chainFromId}`}
						tokens={[item.pool.tokenA, item.pool.tokenB]}
						onClick={() => {
							onFarmClick(item)
						}}
						role="presentation"
						details={[
							{
								label: (
									<APRLabel dataFor={'sis'}>
										APR (SIS)
									</APRLabel>
								),
								value: (
									<APRValue
										tokenA={item.pool.tokenA}
										tokenB={item.pool.tokenB}
										farmingAPR={farmingAPR}
									/>
								),
							},
							{
								label: 'Your liquidity:',
								value: (
									<YourLiquidity
										chainId={item.pool.tokenA.chain.id}
										poolAddress={item.pool.address}
									/>
								),
							},
						]}
					/>
				)
			})}
		</div>
	)
}

export default FarmList
